import * as React from 'react';
import { Icon, StackLayout, TextAction } from '@leagueplatform/genesis-core';
import { NavLink } from 'react-router-dom';

export interface AppHeaderItem {
  id: string;
  name: string;
  path: string;
  icon?: string;
}

export type AppHeaderProps = {
  items: AppHeaderItem[];
  tenantSwitcher?: React.ReactNode;
  children?: React.ReactNode;
};

export const AppHeader = ({
  items,
  tenantSwitcher,
  children,
}: AppHeaderProps) => (
  <StackLayout
    as="header"
    orientation="horizontal"
    verticalAlignment="center"
    spacing="$two"
    css={{
      backgroundColor: '$surfaceBackgroundSecondary',
      padding: '$half $oneAndHalf',
      height: '100%',
    }}
  >
    <StackLayout
      orientation="horizontal"
      verticalAlignment="center"
      spacing="$threeQuarters"
      css={{ flexGrow: 0, flexShrink: 0, whiteSpace: 'nowrap' }}
    >
      {tenantSwitcher}
    </StackLayout>

    <StackLayout
      as="nav"
      orientation="horizontal"
      verticalAlignment="center"
      spacing="$one"
    >
      {items.map((item) => (
        <TextAction
          key={item.id}
          as={NavLink}
          to={item.path}
          emphasis="subtle"
          css={{
            padding: '$quarter $half',
            textDecoration: 'none',
            '&[aria-current=page]': {
              borderBottom: '0.1875rem solid $interactiveActionPrimary',
            },
          }}
        >
          <StackLayout
            orientation="horizontal"
            verticalAlignment="center"
            spacing="$half"
          >
            {item.icon && <Icon icon={item.icon} size="$one" />}
            {item.name}
          </StackLayout>
        </TextAction>
      ))}
    </StackLayout>

    <StackLayout orientation="horizontal" spacing="$one" css={{ flexGrow: 0 }}>
      {children}
    </StackLayout>
  </StackLayout>
);
